import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Input } from 'antd';
import Button from '../../main/components/Button';
import ButtonReport from './ButtonReport';
import icons from '../../main/utils/icons';
import ExpandDropdown from './ExpandDropdown';

export default function Header({
  locales: { admin, common },
  breadcrumbs = [],
  header = null,
  leftButtons = <></>,
  disableBreadcrumbs = false,
  classroomShareLink = null,
  downloadReportButton = false,
  downloadButtonParams,
  modalButton = false,
  onModalButtonClick,
  openModalStatus = 'desc',
  expandDropdownVisible = false,
  expandDropdownItems = [],
  expandDropdownClick = () => {},
  dropdownButtonText = '',
}) {
  const history = useHistory();
  return (
    <div className="admin-header">
      {!disableBreadcrumbs && (
        <div className="admin-header__row space-between">
          <div className="admin-header__row">
            <Button onClick={() => history.goBack()} variant="outline">
              <i className="icon-Back" />
              {common.back}
            </Button>

            <div className="admin-breadcrumbs">
              {breadcrumbs.map((breadcrumb, index) => (
                <Link key={index} to={breadcrumb.to}>
                  {index > 0 && '-'}
                  {breadcrumb.title}
                </Link>
              ))}
            </div>
          </div>
          {classroomShareLink && (
            <div className="admin-header__row end">
              <div className="admin-input-label nowrap h-m-10">Share Link:</div>
              <Input
                className="admin-input"
                style={{ width: 300 }}
                value={classroomShareLink}
              />
            </div>
          )}
        </div>
      )}

      <h1 className="admin-header__row space-between">
        <div
          className={`admin-header__title ${
            expandDropdownVisible ? 'gap-3' : ''
          }`}
        >
          {header || admin.myClassesDashboard}
          {modalButton && (
            <button
              className={`admin-header__title__modal expand-status ${openModalStatus}`}
              onClick={onModalButtonClick}
            >
              {icons.expandIconLarge}
            </button>
          )}
          {expandDropdownVisible && (
            <ExpandDropdown
              dropdownButtonText={dropdownButtonText}
              items={expandDropdownItems}
              onClick={expandDropdownClick}
            />
          )}
        </div>
        <div>{leftButtons}</div>
        {downloadReportButton && (
          <ButtonReport
            href={downloadButtonParams.href}
            fileName={downloadButtonParams.fileName}
          >
            {admin.downloadReport}
          </ButtonReport>
        )}
      </h1>
    </div>
  );
}
